import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-mark',
  imports: [],
  templateUrl: './error-mark.component.html',
  styleUrls: ['./error-mark.component.scss'],
  animations: [
    trigger('errorAnimation', [
      state('hidden', style({ opacity: 0, transform: 'scale(0)' })),
      state('visible', style({ opacity: 1, transform: 'scale(1)' })),
      transition('hidden => visible', [animate('0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)')]),
    ]),
  ],
})
export class ErrorMarkComponent implements OnInit {
  animationState = 'hidden';

  ngOnInit() {
    this.animationState = 'visible';
  }
}
